module.exports = __webpack_public_path__ + "images/help/video-permission@2x-89305aa7ee54480d637580cccc760ade.png";